// extracted by mini-css-extract-plugin
export default {"rectangle":"styles_rectangle__WnSFC","pending":"styles_pending__FgNtN","completed":"styles_completed__At5My","rejected":"styles_rejected__g6tcJ"};